import Vue from 'vue';

const EventBus = new Vue();

const events = [
  'ShowModal',
  'ShowAuthModal',
  'CloseModal',
  'ClosAuthModal',
  'ShowPopper',
  'ClosePopper',
  'UserAgree',
  'TabBarMainButtonClicked',
  'TabBarTabClicked',
  'TabBarButtonClicked',
  'BackgroundMusicMuted',
  'BackgroundMusicPlay',
  'NotificationTriggered',
  'NotificationExpired',
  'ShowSuggester',
  'Tooltip',
  'LevelUp',
  'ClickedProPopup',
  'StartButtonModal',
  'Skeleton',
  'SwitchIsland',
  'PlayExpression',
  'AnnouncementTriggered',
  'AnnouncementExpired',
  'ShowIslandNotification',
  'FetchIslandNotification',
  'ReloadIslandThematics',
  'ContentNotAllowed',
  'IsLessonAudioPlaying',
  'DocumentTitleChanged',
  'PushNotificationStatusChanged',
  'DisableLessonAudioPlayer',
  'StartReadingCardAudio',
  'StopLessonAudioPlayer',
  'TranscriptPartialResult',
  'SkipTest',
  'ShowLessonHelperContent',
  'StartTimer',
  'StopTimer',
  'ShowTimerStopModal',
  'InitLessons',
  'ShowJoinPopup',
  'ShowTeachbotPanelPulseEffect',
  'ContentLoaded',
  'ChangeSettingsPopper',
  'ClickedKeyboardAddition',
  'SessionLeft',
  'ClearPresisUsageDataInterval',
  'LessonWasFinishedByUser',
  'CloseModalOrPopper',
  'CloseLanguageSelectorIsland',
  'SendGapTypingText',
  'SetGapTypingText',
  'UpdateGapTypingIsLastGap',
  'GapTypingAllOptionFilled',
  'GapTypingInputChanged',
  'StartReplay',
  'TeachbotPlayError',
];

events.forEach((eventName) => {
  EventBus[`on${eventName}`] = (component, callback) => {
    EventBus.$on(eventName, callback);
  };
  EventBus[`off${eventName}`] = (component, callback) => {
    EventBus.$off(eventName, callback);
  };
  EventBus[eventName.charAt(0).toLowerCase() + eventName.slice(1)] = (payload) => {
    EventBus.$emit(eventName, payload);
  };
});

export default EventBus;
